import { Outlet } from 'react-router';
import { AppLayout } from './AppLayout';

/**
 * Layout wrapper for all LYW routes. TourProvider lives at app root, so the tour
 * persists regardless of route or layout changes.
 */
export function LywLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
